module.exports = __webpack_public_path__ + "static/media/undraw_co-workers_ujs6.538bc4b0.svg";